/* Membership customise — appliance selection.

   The tier comes from ?tier=silver|gold|platinum. It is read here rather than in
   Liquid because Shopify Liquid cannot see a query string at all — there is no
   request member that exposes one. All three tiers are emitted into the page and
   this file picks the one the URL asked for.

   Every figure is read from that JSON, which Liquid filled from the
   configuration metaobject. Nothing is hardcoded here. Money is in cents. */
(function () {
  var root = document.querySelector('[data-ff-customise]');
  if (!root) return;

  var d = root.dataset;
  var body = root.querySelector('[data-ff-body]');
  /* d.cartUrl and d.checkoutUrl come straight from data-cart-url and
     data-checkout-url via the DOM dataset API - nothing to wire up. */
  var noTier = root.querySelector('[data-ff-no-tier]');

  var TIERS = {};
  try {
    TIERS = JSON.parse(root.querySelector('[data-ff-tiers]').textContent);
  } catch (e) { TIERS = {}; }

  /* No-appliance still needs the Membership Terms agreed to before payment.
     That happens on a dedicated order-review page, not here - see
     goToOrderReview() below. */

  function param(name) {
    var m = new RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
    return m ? decodeURIComponent(m[1]) : '';
  }

  /* Remembered across a sign-in redirect, which drops the query string. */
  var tier = String(
    (window.FFJourney ? window.FFJourney.param('tier') : param('tier')) || ''
  ).toLowerCase();

  /* Shopify's new customer accounts often ignore return_url and drop the
     member on their account page. If they arrive here signed in with a
     saved route and no tier in the URL, put it back rather than making
     them start over. */
  if (window.FFJourney && window.FFJourney.resume('tier')) return;


  /* If no tier in the URL, use the member's existing tier from their
     membership metafield. This lets existing members reach this page from
     the account panel without getting "choose a membership first". */
  if (!TIERS[tier] && d.memberTier) tier = d.memberTier.toLowerCase();

  /* Preview assumes Silver when the URL carries no tier, so the page can be
     opened directly during development. The prices on it are the real
     configured ones - only the tier choice is assumed. */
  if (!TIERS[tier] && d.preview) tier = 'silver';

  /* Never guess a tier. Someone who arrives without one is sent back to choose,
     rather than shown a membership they did not pick and a price for it. */
  if (!TIERS[tier]) {
    if (noTier) noTier.hidden = false;
    return;
  }

  var T = TIERS[tier];
  var fees = { none: T.none, air: T.air, freezer: T.freezer, both: T.both };
  var standard = T.standard;
  var chosen = standard;

  var COPY = {
    both:    { h: 'Both Appliances',    p: 'Store it and cook it. The complete setup.' },
    freezer: { h: 'Chest Freezer Only', p: 'Add storage. Buy a full month at once.' },
    air:     { h: 'Air Fryer Only',     p: 'Keep it simple. Cook straight from frozen.' },
    none:    { h: 'No Appliance',       p: 'More meal value, nothing to store.' }
  };
  var NOTE = {
    none: 'No appliance', air: 'Air fryer included',
    freezer: 'Chest freezer included', both: 'Both appliances included'
  };
  var ORDER = ['both', 'freezer', 'air', 'none'];

  /* Images come from the section settings via data attributes. "Both" uses
     both images side by side; "none" has no image. */
  var imgAir = d.imgAir || '';
  var imgFreezer = d.imgFreezer || '';
  var imgNone = d.imgNone || '';
  var IMGS = {
    air: imgAir,
    freezer: imgFreezer,
    both: imgAir || imgFreezer,
    none: imgNone
  };

  function money(cents) {
    return 'R ' + (cents / 100).toLocaleString('en-ZA');
  }

  function fill(selector, text) {
    Array.prototype.forEach.call(root.querySelectorAll(selector), function (el) {
      el.textContent = text;
    });
  }

  function render() {
    var wrap = root.querySelector('[data-ff-options]');
    wrap.innerHTML = ORDER.map(function (k) {
      var diff = fees[k] - fees[standard];
      var label = diff === 0
        ? '<div class="ff-delta flat">Standard &middot; ' + money(fees[k]) + '</div>'
        : '<div class="ff-delta">' + (diff < 0 ? '\u2212' : '+') +
          money(Math.abs(diff)) + ' &middot; ' + money(fees[k]) + ' total</div>';
      return '<button type="button" class="ff-opt' + (k === chosen ? ' sel' : '') +
        '" data-choice="' + k + '"><div class="ff-ipanel">' +
        (function () {
          if (k === 'both' && imgAir && imgFreezer) {
            return '<img src="' + imgAir + '" alt="Air fryer" style="width:48%;display:inline-block">'
              + '<img src="' + imgFreezer + '" alt="Chest freezer" style="width:48%;display:inline-block;margin-left:4%">';
          }
          return IMGS[k] ? '<img src="' + IMGS[k] + '" alt="' + COPY[k].h + '">' : '';
        })() +
        (k === standard ? '<span class="ff-inc">Included</span>' : '') +
        '</div><h4>' + COPY[k].h + '</h4><p>' + COPY[k].p + '</p>' + label + '</button>';
    }).join('');

    Array.prototype.forEach.call(wrap.querySelectorAll('[data-choice]'), function (b) {
      b.addEventListener('click', function () { chosen = b.dataset.choice; render(); });
    });

    var part = fees[chosen] - fees.none;
    root.querySelector('[data-ff-appl]').textContent =
      part === 0 ? 'R 0' : '+' + money(part);
    root.querySelector('[data-ff-appl-note]').textContent = NOTE[chosen];
    root.querySelector('[data-ff-total]').textContent = money(fees[chosen]);
    var btn = root.querySelector('[data-ff-continue]');
    if (chosen === 'none') {
      /* Direct cart add, no href - the click handler below takes over. */
      btn.removeAttribute('href');
    } else {
      btn.setAttribute('href', d.next + '?tier=' + tier + '&appliance=' + chosen);
    }
  }

  function showError(msg) {
    var e = root.querySelector('[data-ff-continue-error]');
    e.hidden = false;
    e.textContent = msg;
  }

  /* No-appliance still needs the Membership Terms agreed to before payment -
     the order-review page is that step. Cart add and checkout happen from
     there, not here. */
  function remember() {
    if (window.FFJourney) {
      window.FFJourney.save({ tier: tier, appliance: chosen });
    }
  }

  function goToOrderReview(ev) {
    remember();
    if (chosen !== 'none') return;   // let the normal href navigation happen
    ev.preventDefault();
    window.location.href = (d.reviewUrl || '/pages/membership-order-review') +
      '?tier=' + tier;
  }

  root.querySelector('[data-ff-continue]').addEventListener('click', goToOrderReview);

  /* Tier name and limit were rendered by Liquid before the tier moved to the
     client. They are filled here now, in every place they appear. */
  fill('[data-ff-tier-name]', T.name);
  fill('[data-ff-limit]', money(T.limit));

  if (body) body.hidden = false;
  render();
})();
